<template>
<div class="schedule-select" v-if="disable">
    <el-time-select :picker-options="{start: '00:00',step: '00:15',end: '23:45'}" v-model="time" placeholder="select" :clearable="false" :editable="false"></el-time-select>
    <div style="margin-top:10px;">
        <div @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" v-for="(item, index) in weekData" :key="index" @click="checkWeekDay(index)" :class="[weekArr.includes(index+1)&&!disable?'click-weekday':'',weekArr.includes(index+1)&&disable?'click-weekday-disable':'',hoverCurrent==index&&'every-weekday-hover','every-weekday']">
            {{item.name}}
        </div>
    </div>
</div>
</template>

<script>
// import timeSelector from "@/components/common/selector/time_selector";
export default {
    props: ['disable'],
    components: {
        // "time-selector": timeSelector
    },
    data: function () {
        return {
            weekData: [{
                name: this.$t('language.popup.sunday')
            }, {
                name: this.$t('language.popup.monday')
            }, {
                name: this.$t('language.popup.tuesday')
            }, {
                name: this.$t('language.popup.wednesday')
            }, {
                name: this.$t('language.popup.thursday')
            }, {
                name: this.$t('language.popup.friday')
            }, {
                name: this.$t('language.popup.saturday')
            }],
            weekArr: [],
            hoverCurrent: -1,
            time: new Date(),
        }
    },
    methods: {
        // 每15分钟向上取整
        getNextQuarterHour() {
            let now = new Date();
            let minutes = now.getMinutes();
            let diffMinutes = Math.ceil(minutes / 15) * 15 - minutes;
            now.setMinutes(now.getMinutes() + diffMinutes);
            if (now.getMinutes() === 60) {
                now.setMinutes(0);
                now.setHours(now.getHours() + 1);
            }
            return now;
        },
        //初始化日期
        initDate(schedules) {
            if(schedules&&schedules.weeks) {
                this.weekArr = this.judgeShowWeeklyPage(schedules.weeks);
                this.time = schedules.times[0];
            }else {
                this.weekArr = [];

                let nowDate = this.getNextQuarterHour();
                let h = nowDate.getHours();
                if (h < 10) {
                    h = '0' + h;
                }
                let m = nowDate.getMinutes();
                if (m < 10) {
                    m = '0' + m;
                }
                this.time = h+":"+m;
            }
        },
        //选中日期
        checkWeekDay(index) {
            if (this.weekArr.includes(index+1)) {
                this.weekArr = this.weekArr.filter(
                    function (ele) {
                        return ele != index+1;
                    });
            } else {
                var value = parseInt(index)+1;
                this.weekArr.push(value);
            }
        },
        //判断显示Weekly界面
        judgeShowWeeklyPage(weeks) {
            let weeksArr = [];
            $.each(weeks, function(i, weekItem) {
                if ((typeof weekItem == 'string') && weekItem.constructor == String) {
                    weekItem.replace(/\"/g, "")
                }
                weekItem = parseInt(weekItem);
                weeksArr.push(weekItem);
            });
            return weeksArr;
        },
        //获取日期
        getRunTime() {
            if(this.weekArr.length>0&&this.time) {
                let that = this;
                let weeks = [];
                $.each(this.weekArr, function (weekIndex, weekItem) {
                    if (weekItem != null && weekItem != undefined && weekItem != "" && !window.isNaN(weekItem)) {
                        weeks.push(parseInt(weekItem));
                    }
                    if (weekItem == 0) {
                        weeks.push(weekItem);
                    }
                });

                weeks.sort((a, b) => a - b);
    
                var schedules = {
                    type: 'Weekly',
                    weeks: Object.assign([], weeks),
                    times: [that.time],
                }
    
                return schedules;
            }
        }
    },
}
</script>

<style scoped>
.every-weekday {
    border: 1px solid #DCE4F5;
    /*no*/
    width: 90px;
    /*no*/
    height: 30px;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    font-size: 14px;
    /*no*/
    float: left;
    margin-right: -1px;
    /*no*/
    margin-bottom: -1px;
    /*no*/
    cursor: pointer;
}

.every-weekday-disable {
    border: 1px solid #DCE4F5;
    /*no*/
    width: 90px;
    /*no*/
    height: 30px;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    font-size: 14px;
    /*no*/
    float: left;
    color: #d2d4d8;
    pointer-events: none;
}

.every-weekday-hover {
    background: #5562B4;
    color: #fff;
}

.click-weekday {
    border: none;
    background: #7987E2;
    color: #fff;
}

.click-weekday-disable {
    background: #5562B4;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_schedule/tab_weekly.vue